import { render, staticRenderFns } from "./ButlerServe.vue?vue&type=template&id=3ace0d64&scoped=true&"
import script from "./ButlerServe.vue?vue&type=script&lang=js&"
export * from "./ButlerServe.vue?vue&type=script&lang=js&"
import style0 from "./ButlerServe.vue?vue&type=style&index=0&id=3ace0d64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace0d64",
  null
  
)

export default component.exports